import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=271ab65d&"
import script from "./TableCell.vue?vue&type=script&lang=js&"
export * from "./TableCell.vue?vue&type=script&lang=js&"
import style0 from "./TableCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports